/**
 * @Author: DJ
 * @Date:   2021-07-09 14:20:45
 * @Last Modified by:   DJ
 * @Last Modified time: 2022-06-09 15:15:03
 */
/**
 * 路由配置
 */
import Login from '../views/login';
import Home from '../views/home';
import Welcome from '../views/home/welcome';
import Setting from '../views/setting';
import { WorkBenchCard } from '../views/workbench';
import { UserCard, Member, Agent, Rider, Black, MicroBusinesses, Crowdsourcing } from '../views/user';
import AsyncComponent from './asyncComponent.js';
import { AfterSaleCard, Deliverycomplain, Deliveryeval, Deliveryticket, Suggestions, Distributionorderassign } from '../views/aftersale';
import { OrderCard, Distributionorder, Serviceorder, Insuranceorder, VirtualNo, MicroShippingOrder } from '../views/order';
import { ClientCard, Slide, Mood, Article, Strategy, Instruction, MessageMove, School } from '../views/client';
import { marketingCard, CardCentre, Accumulate, Eventtouch } from '../views/market';
import { ContractCard, ContractList, Templatetrac } from '../views/contract';
import { AccountFlow, TaxDeclaration, PlatformWallet, AccountStatement, PayManage, BankTransaction, Financecd, CollectionManage, PlatformSubsidy, EnterpriseRecharge, ProvisionalTaxRegister, EnterpriseReconciliation, MicroBusinessesStatements, Microtransportstatements, MicroImportOrder, Refund, TransportCompanyWallet } from '../views/finance';
import { PerCard, Structure, Employee, Assignauthority, MenuConfig } from '../views/permissions';
import { Companyhelpcd, SearchHelp, Materialdownload } from '../views/companyhelp';
import { OperationCompany, OperationService, OperationCity, Operationcd, OperationTransportCompany } from '../views/operation';
import { ReportCard, ReportTemplate, ReportRecord } from '../views/report';
import { AuditList, Auditcd, PictureNickname, HealthCertificate } from '../views/audit';
import { ShippingFeeSet, RiderLevelSet, Versions, BaseInfo, QualificationInfo, AreaInfo, FinancialInfo, Parameter, Rate, FeedbackType, Riskcontrol, Financialset, OperatingRule, Dictionaries, systemCard, SensitiveWord } from '../views/system';

// 用户管理   
const userRoutes = [
    { path: '/member', title: '会员管理', component: Member },
    { path: '/member/detail/:id/:isEp', title: '会员详情', component: AsyncComponent(() => import('@/views/user/member/user/detail')), show: 'none' },
    { path: '/member/companyDetail/:userid/:id', title: '企业详情', component: AsyncComponent(() => import('@/views/user/member/company/detail')), show: 'none' },
    { path: '/member/shippingfeeset/:curTabID/:id', title: '运费模板详情', component: AsyncComponent(() => import('@/views/system/shippingfeeset/detailFee')), show: 'none' },
    { path: '/agent', title: '经纪人管理', component: Agent },
    { path: '/agent/detail/:id', title: '经纪人详情', component: AsyncComponent(() => import('@/views/user/agent/detail')), show: 'none' },
    { path: '/agent/invite', title: '邀请经纪人', component: AsyncComponent(() => import('@/views/user/agent/invite')), show: 'none' },
    { path: '/rider', title: '骑士管理', component: Rider },
    { path: '/rider/detail/:id/:smallTransportId?', title: '骑士详情', component: AsyncComponent(() => import('@/views/user/rider/detail')), show: 'none' },
    { path: '/black', title: '黑名单', component: Black },
    { path: '/black/history/:id/:type', title: '历史记录', component: AsyncComponent(() => import('@/views/user/black/history')), show: 'none' },
    { path: '/microbusinesses', title: '微企管理', component: MicroBusinesses },
    { path: '/microbusinesses/companyDetail/:id', title: '微企详情', component: AsyncComponent(() => import('@/views/user/microBusinesses/company/detail')), show: 'none' },
    { path: '/microbusinesses/create', title: '新建微企', component: AsyncComponent(() => import('@/views/user/microBusinesses/company/main/createMicorEp')), show: 'none' },
];

// 权限管理
const permissionsRoutes = [
    { path: '/structure', title: '架构管理', component: Structure },
    { path: '/employee', title: '员工管理', component: Employee },
    { path: '/employee/operate/add', title: '新增员工', component: AsyncComponent(() => import('@/views/permissions/employee/operate')), show: 'none' },
    { path: '/employee/operate/edit/:id', title: '编辑员工', component: AsyncComponent(() => import('@/views/permissions/employee/operate')), show: 'none' },
    { path: '/assignauthority', title: '分配权限', component: Assignauthority },
    { path: '/menuconfig', title: '菜单配置', component: MenuConfig },
];

// 客户端管理
const clientRoutes = [
    {
        path: '/baseset', title: '基础管理', childrenNode: [
            { path: '/slide', title: '幻灯片管理', component: Slide },
            { path: '/slide/manage/:sign', title: '广告管理', component: AsyncComponent(() => import('@/views/client/baseset/slide/manage')), show: 'none' },
            { path: '/slide/manage/:sign/:type', title: '新建广告', component: AsyncComponent(() => import('@/views/client/baseset/slide/manage/detail')), show: 'none' },
            { path: '/slide/manage/:sign/:type/:id', title: '编辑广告/广告详情', component: AsyncComponent(() => import('@/views/client/baseset/slide/manage/detail')), show: 'none' },
            { path: '/mood', title: '心情管理', component: Mood },
            { path: '/mood/:type/:id', title: '心情编辑/心情详情', component: AsyncComponent(() => import('@/views/client/baseset/mood/detail')), show: 'none' },
            { path: '/article', title: '物品管理', component: Article },
        ]
    },
    {
        path: '/help', title: '帮助中心', childrenNode: [
            { path: '/strategy', title: '攻略分类', component: Strategy },
            { path: '/strategy/article/:id', title: '攻略列表', component: AsyncComponent(() => import('@/views/client/help/strategy/article')), show: 'none' },
            { path: '/strategy/article/:id/:type', title: '攻略详情', component: AsyncComponent(() => import('@/views/client/help/strategy/article/detail')), show: 'none' },
            { path: '/strategy/article/:id/:type/:aid', title: '攻略详情', component: AsyncComponent(() => import('@/views/client/help/strategy/article/detail')), show: 'none' },
            { path: '/instruction', title: '初始说明', component: Instruction },
            { path: '/instruction/:type/:id/:curTabID', title: '说明详情', component: AsyncComponent(() => import('@/views/client/help/instruction/detail')), show: 'none' },
        ]
    },
    { path: '/messageMove', title: '消息推送', component: MessageMove },
    { path: '/messageMove/detail/:id', title: '查看详情', component: AsyncComponent(() => import('@/views/client/messageMove/pages/detail')), show: 'none' },
    { path: '/messageMove/edit/:id', title: '编辑消息', component: AsyncComponent(() => import('@/views/client/messageMove/pages/edit')), show: 'none' },
    { path: '/messageMove/add', title: '新建消息', component: AsyncComponent(() => import('@/views/client/messageMove/pages/add')), show: 'none' },
    { path: '/school', title: '普惠学院', component: School },
    { path: '/school/addLession', title: '新建课程', component: AsyncComponent(() => import('@/views/client/school/pages/addLession')), show: 'none' },
    { path: '/school/editLession/:id', title: '编辑课程', component: AsyncComponent(() => import('@/views/client/school/pages/editLession')), show: 'none' },
];

// 订单管理
const orderRoutes = [
    { path: '/distributionorder', title: '配送订单', component: Distributionorder },
    { path: '/distributionorder/orderdetail/:id/:lat/:lng/:userId', title: '骑士列表', component: AsyncComponent(() => import('@/views/order/distributionorder/riderorder')), show: 'none' },
    { path: '/distributionorder/orderdetail/:id', title: '查看详情', component: AsyncComponent(() => import('@/views/order/distributionorder/orderdetail')), show: 'none' },
    { path: '/distributionorder/multiorderdetail/:id', title: '查看详情', component: AsyncComponent(() => import('@/views/order/distributionorder/multiorderdetail')), show: 'none' },
    { path: '/distributionorder/orderhistory/:id', title: '订单日志', component: AsyncComponent(() => import('@/views/order/distributionorder/orderhistory')), show: 'none' },
    { path: '/serviceorder', title: '增值服务订单', component: Serviceorder },
    { path: '/serviceorder/orderdetail/:id', title: '查看详情', component: AsyncComponent(() => import('@/views/order/serviceorder/orderdetail')), show: 'none' },
    { path: '/insuranceorder', title: '保险单', component: Insuranceorder, show: process.env.TYPE == 'OC' ? 'none' : null },
    { path: '/insuranceorder/orderdetail/:id', title: '查看详情', component: AsyncComponent(() => import('@/views/order/insuranceorder/orderdetail')), show: 'none' },
    { path: '/virtualno', title: '虚拟通信记录', component: VirtualNo },
    { path: '/microshippingorder', title: '微企配送订单', component: MicroShippingOrder },
    { path: '/microshippingorder/orderdetail/:id', title: '查看详情', component: AsyncComponent(() => import('@/views/order/microshippingorder/orderdetail')), show: 'none' },
    { path: '/microshippingorder/orderhistory/:id', title: '查看日志', component: AsyncComponent(() => import('@/views/order/microshippingorder/orderhistory')), show: 'none' },
];

// 售后管理
const salesRoutes = [
    { path: '/deliverycomplain', title: '配送投诉', component: Deliverycomplain },
    { path: '/deliverycomplain/orderdetail/:id', title: '查看详情', component: AsyncComponent(() => import('@/views/aftersale/deliverycomplain/pages/detailInfo')), show: 'none' },
    // { path: '/distributionorderassign', title: '配送订单指派', component: Distributionorderassign },
    // { path: '/distributionorderassign/orderdetail/:id/:lat/:lng/:userId', title: '骑士列表', component: AsyncComponent(() => import('@/views/aftersale/distributionorderassign/orderdetail')), show: 'none' },
    // { path: '/distributionorderassign/orderhistory/:id', title: '订单日志', component: AsyncComponent(() => import('@/views/aftersale/distributionorderassign/orderhistory')), show: 'none' },
    { path: '/deliverycomplain/handle/:id', title: '投诉处理', component: AsyncComponent(() => import('@/views/aftersale/deliverycomplain/pages/handleInfo')), show: 'none' },
    { path: '/deliveryeval', title: '评价管理', component: Deliveryeval },
    { path: '/deliveryeval/:tel', title: '评价管理', component: AsyncComponent(() => import('@/views/aftersale/deliveryeval/pages/main')), show: 'none' },
    { path: '/deliveryeval/orderdetail/:id', title: '查看详情', component: AsyncComponent(() => import('@/views/aftersale/deliveryeval/pages/detailInfo')), show: 'none' },
    { path: '/deliveryticket', title: '罚单列表', component: Deliveryticket },
    { path: '/deliveryticket/:tel', title: '罚单列表', component: AsyncComponent(() => import('@/views/aftersale/deliveryticket/pages/main')), show: 'none' },
    { path: '/deliveryticket/detail/:id', title: '查看详情', component: AsyncComponent(() => import('@/views/aftersale/deliveryticket/pages/detailInfo')), show: 'none' },
    { path: '/deliveryticket/appeal/:id', title: '处理', component: AsyncComponent(() => import('@/views/aftersale/deliveryticket/pages/appealInfo')), show: 'none' },
    { path: '/suggestions', title: '意见反馈', component: Suggestions },
];

// 营销管理
const marketRoutes = [
    { path: '/cardcentre', title: '卡券中心', component: CardCentre, },
    { path: '/cardcentre/createinfo', title: '新建卡券', component: AsyncComponent(() => import('@/views/market/cardcentre/pages/createinfo')), show: 'none' },
    { path: '/cardcentre/detailinfo/:id', title: '卡券详情', component: AsyncComponent(() => import('@/views/market/cardcentre/pages/detailinfo')), show: 'none' },
    { path: '/cardcentre/editorinfo/:id', title: '卡券编辑', component: AsyncComponent(() => import('@/views/market/cardcentre/pages/editorinfo')), show: 'none' },
    { path: '/eventtouch', title: '事件触达', component: Eventtouch, },
    { path: '/eventtouch/createinfo', title: '新建事件', component: AsyncComponent(() => import('@/views/market/eventtouch/pages/createinfo')), show: 'none' },
    { path: '/eventtouch/detailinfo/:id', title: '事件详情', component: AsyncComponent(() => import('@/views/market/eventtouch/pages/detailinfo')), show: 'none' },
    { path: '/eventtouch/editorinfo/:id', title: '事件编辑', component: AsyncComponent(() => import('@/views/market/eventtouch/pages/editorinfo')), show: 'none' },
    { path: '/accumulaterule', title: '积分规则', component: Accumulate, },
    { path: '/accumulaterule/setting', title: '设置积分产生策略', component: AsyncComponent(() => import('@/views/market/accumulaterule/setting')), show: 'none', },
];

// 合同管理  
const contractRoutes = [
    { path: '/contractlist', title: '合同列表', component: ContractList, },
    { path: '/contractlist/contractlistment/:id', title: '合同列表-管理', component: AsyncComponent(() => import('@/views/contract/contractlist/contractlistment')), show: 'none' },
    { path: '/contractlist/createinfo/:code', title: '新建协议', component: AsyncComponent(() => import('@/views/contract/contractlist/createinfo')), show: 'none' },
    { path: '/contractlist/detailinfo/:id/:code', title: '协议详情', component: AsyncComponent(() => import('@/views/contract/contractlist/detailinfo')), show: 'none' },
    { path: '/contractlist/editorinfo/:id/:code', title: '编辑协议', component: AsyncComponent(() => import('@/views/contract/contractlist/editorinfo')), show: 'none' },
    { path: '/templatetrac', title: '合同模板', component: Templatetrac, },
    { path: '/templatetrac/list/:id', title: '已签署合同', component: AsyncComponent(() => import('@/views/contract/templatetrac/list')), show: 'none', },
];

//市场管理
const operationRoutes = [
    { path: '/company', title: '运营公司', component: OperationCompany },
    { path: '/company/detail/:id', title: '运营公司详情', component: AsyncComponent(() => import('@/views/operation/company/detail')), show: 'none' },
    { path: '/company/create', title: '创建运营公司', component: AsyncComponent(() => import('@/views/operation/company/cepage')), show: 'none' },
    { path: '/company/edit/:id', title: '编辑运营公司', component: AsyncComponent(() => import('@/views/operation/company/cepage')), show: 'none' },
    { path: '/company/change/:id', title: '变更运营公司', component: AsyncComponent(() => import('@/views/operation/company/cepage')), show: 'none' },
    { path: '/company/raterecord/:id', title: '费率历史记录', component: AsyncComponent(() => import('@/views/operation/company/raterecord')), show: 'none' },
    { path: '/service', title: '增值服务', component: OperationService },
    { path: '/service/detail/:id', title: '增值服务详情', component: AsyncComponent(() => import('@/views/operation/service/cdepage')), show: 'none' },
    { path: '/service/edit/:id', title: '编辑增值服务', component: AsyncComponent(() => import('@/views/operation/service/cdepage')), show: 'none' },
    { path: '/city', title: '城市管理', component: OperationCity },
    { path: '/transportCompany', title: '小运力公司', component: OperationTransportCompany },
    { path: '/transportCompany/detail/:id', title: '小运力公司详情', component: AsyncComponent(() => import('@/views/operation/transportCompany/detail')), show: 'none' },
];

//审核管理
const auditRoutes = [
    { path: '/list', title: '审核列表', component: AuditList },
    { path: '/list/brokerinfo/:companyId/:id', title: '经纪人详情', component: AsyncComponent(() => import('@/views/audit/list/detail/broker')), show: 'none' },
    { path: '/list/auditbroker/:companyId/:id', title: '审核经纪人', component: AsyncComponent(() => import('@/views/audit/list/audit/broker')), show: 'none' },
    { path: '/list/operatorinfo/:companyId/:id', title: '运营公司详情', component: AsyncComponent(() => import('@/views/audit/list/detail/operator')), show: 'none' },
    { path: '/list/auditoperator/:companyId/:id', title: '审核运营公司', component: AsyncComponent(() => import('@/views/audit/list/audit/operator')), show: 'none' },
    { path: '/picturenickname', title: '头像昵称', component: PictureNickname },
    { path: '/healthcertificate', title: '健康证审核', component: HealthCertificate },
    { path: '/healthcertificate/view/:id/:loginUserId', title: '审核详情', component: AsyncComponent(() => import('@/views/audit/healthcertificate/certificateInfo')), show: 'none' },
    { path: '/healthcertificate/audit/:id/:riderId/:loginUserId', title: '审核', component: AsyncComponent(() => import('@/views/audit/healthcertificate/certificateAudit')), show: 'none' },
];

//系统设置 
const systemRoutes = [
    { path: '/parameter', title: '参数设置', component: Parameter },
    { path: '/shippingfeeset', title: '配送费设置', component: ShippingFeeSet },
    { path: '/shippingfeeset/tab:tabId', title: '配送费设置', component: ShippingFeeSet, show: 'none' },
    { path: '/shippingfeeset/createfee/:curTabID', title: '新建配送费', component: AsyncComponent(() => import('@/views/system/shippingfeeset/createFee')), show: 'none' },
    { path: '/shippingfeeset/editfee/:id/:curTabID', title: '编辑配送费', component: AsyncComponent(() => import('@/views/system/shippingfeeset/editFee')), show: 'none' },
    { path: '/riderlevelset', title: '骑手等级', component: RiderLevelSet },
    { path: '/riderlevelset/createlevel', title: '添加骑手等级', component: AsyncComponent(() => import('@/views/system/riderlevelset/cdepage')), show: 'none' },
    { path: '/riderlevelset/editlevel/:id', title: '编辑骑手等级', component: AsyncComponent(() => import('@/views/system/riderlevelset/cdepage')), show: 'none' },
    { path: '/versions', title: '版本管理', component: Versions },
    { path: '/versions/create', title: '新建版本', component: AsyncComponent(() => import('@/views/system/versions/cdepage')), show: 'none' },
    { path: '/versions/detail/:id', title: '版本详情', component: AsyncComponent(() => import('@/views/system/versions/cdepage')), show: 'none' },
    { path: '/versions/edit/:id', title: '编辑版本', component: AsyncComponent(() => import('@/views/system/versions/cdepage')), show: 'none' },
    { path: '/baseinfo', title: '基础详情', type: 'company', component: BaseInfo },
    { path: '/qualificationinfo', title: '经营资质', type: 'company', component: QualificationInfo },
    { path: '/areainfo', title: '运营区域', type: 'company', component: AreaInfo },
    { path: '/financialinfo', title: '财务信息', type: 'company', component: FinancialInfo },
    { path: '/rate', title: '计费比例设置', component: Rate },
    { path: '/rate/historical/:id', title: '历史记录', component: AsyncComponent(() => import('@/views/system/rate/historical')), show: 'none' },
    { path: '/feedbacktype', title: '反馈类型', component: FeedbackType },
    // { path: '/riskcontrol', title: '风控管理', component: Riskcontrol },
    { path: '/financialset', title: '财务设置', component: Financialset },
    { path: '/operatingrule', title: '运营规则', component: OperatingRule },
    { path: '/operatingrule/createInfo', title: '新建规则', component: AsyncComponent(() => import('@/views/system/operatingrule/pages/sendRule/createInfo')), show: 'none' },
    { path: '/operatingrule/editInfo/:id', title: '编辑规则', component: AsyncComponent(() => import('@/views/system/operatingrule/pages/sendRule/editInfo')), show: 'none' },
    { path: '/dictionaries', title: '攻略分类字典', component: Dictionaries },
    { path: '/sensitiveword', title: '敏感词库', component: SensitiveWord },
];

//财务管理
const financeRoutes = [
    // { path: '/balanceshow', title: '账户余额', component: BalanceShow },
    { path: '/platformwallet', title: '平台钱包账户', component: PlatformWallet },
    { path: '/refund', title: '退款列表', component: Refund },
    { path: '/accountflow', title: '账户流水', component: AccountFlow },
    { path: '/banktransaction', title: '银行交易明细', component: BankTransaction },
    // { path: '/taxdeclaration', title: '个税申报', component: TaxDeclaration },
    { path: '/accountstatement', title: '运营公司对账单', component: AccountStatement },
    { path: '/accountstatement/detail/:id', title: '运营中心对账单详情', component: AsyncComponent(() => import('@/views/finance/accountstatement/detail')), show: 'none' },
    { path: '/enterprisereconciliation', title: '企业对账单', component: EnterpriseReconciliation },
    { path: '/enterprisereconciliation/reconciliation/detail/:id', title: '对账单详情', component: AsyncComponent(() => import('@/views/finance/enterprisereconciliation/reconciliation/detail')), show: 'none' },
    { path: '/enterprisereconciliation/reconciliationcycle/detail/:userid/:id', title: '企业详情', component: AsyncComponent(() => import('@/views/user/member/company/detail')), show: 'none' },
    { path: '/paymanage', title: '付款管理', component: PayManage },
    { path: '/paymanage/:type/:id/:curTabID', title: '付款详情', component: AsyncComponent(() => import('@/views/finance/paymanage/default/detail')), show: 'none' },
    { path: '/collectionmanage', title: '收款管理', component: CollectionManage },
    { path: '/collectionmanage/detail/:id', title: '收款单详情', component: AsyncComponent(() => import('@/views/finance/collectionmanage/detail')), show: 'none' },
    { path: '/platformsubsidy', title: '平台补贴', component: PlatformSubsidy },
    { path: '/enterpriserecharge', title: '企业会员预付款记录', component: EnterpriseRecharge },
    { path: '/provisionaltaxregister', title: '临时税务登记证', component: ProvisionalTaxRegister },
    { path: '/provisionaltaxregister/detail/:id', title: '登记证详情', component: AsyncComponent(() => import('@/views/finance/provisionaltaxregister/detail')), show: 'none' },
    { path: '/microbusinessesstatements', title: '微企对账单', component: MicroBusinessesStatements },
    { path: '/microbusinessesstatements/detail/:reconId', title: '微企对账单详情', component: AsyncComponent(() => import('@/views/finance/microbusinessesstatements/detail')), show: 'none' },
    { path: '/microimportorder', title: '微企订单导入', component: MicroImportOrder },
    { path: '/microtransportstatements', title: '小运力公司对账单', component: Microtransportstatements },
    { path: '/microtransportstatements/detail/:settleMode/:reconId', title: '小运力公司对账单详情', component: AsyncComponent(() => import('@/views/finance/microtransportstatements/detail')), show: 'none' },
    { path: '/transportCompanyWallet', title: '小运力公司钱包', component: TransportCompanyWallet },
    { path: '/transportCompanyWallet/accountDetail/:id', title: '账户明细', component: AsyncComponent(() => import('@/views/finance/transportCompanyWallet/accountDetail')), show: 'none' },
    { path: '/transportCompanyWallet/cashRecord/:id', title: '提现记录', component: AsyncComponent(() => import('@/views/finance/transportCompanyWallet/cashRecord')), show: 'none' },
];

// 运营帮助中心
const companyHelpRoutes = [
    { path: '/searchhelp', title: '帮助中心', component: SearchHelp },
    { path: '/searchhelp/:searchKey', title: '攻略分类', component: AsyncComponent(() => import('@/views/companyhelp/searchhelp/main')), show: 'none' },
    { path: '/searchhelp/strategy/:classId', title: '攻略列表', component: AsyncComponent(() => import('@/views/companyhelp/searchhelp/strategy')), show: 'none' },
    { path: '/searchhelp/strategy/:classId/:id', title: '攻略详情', component: AsyncComponent(() => import('@/views/companyhelp/searchhelp/strategy/detail')), show: 'none' },
    { path: '/searchhelp/strategy/:classId/:id/:searchKey', title: '攻略详情', component: AsyncComponent(() => import('@/views/companyhelp/searchhelp/strategy/detail')), show: 'none' },
    { path: '/materialdownload', title: '物料下载', component: Materialdownload },
];

// 报表管理
const reportRoutes = [
    { path: '/reporttemplate', title: '报表模版管理', component: ReportTemplate },
    { path: '/reporttemplate/detail/:id', title: '模版详情', component: AsyncComponent(() => import('@/views/report/reporttemplate/detail')), show: 'none' },
    { path: '/reportrecord', title: '报表生成记录', component: ReportRecord },
    { path: '/reportrecord/:type/:id', title: '生成报表', component: AsyncComponent(() => import('@/views/report/reportrecord/detail')), show: 'none' },
];

// 路由配置
const routes = [
    { path: '/', component: Login, exact: true },
    { path: '/login', component: Login },
    {
        path: '/home', component: Home, routes: [
            { path: '/', title: '首页', component: Welcome, exact: true },
            { path: '/setting', title: '个人设置', component: Setting },
            // {
            //     path: '/workbench',
            //     icon_up: (require('@/assets/image/topnav/workbench_up.png').default),
            //     icon_down: (require('@/assets/image/topnav/workbench_down.png').default),
            //     title: '工作台',
            //     component: WorkBenchCard,
            // },
            {
                path: '/operation',
                icon_up: (require('@/assets/image/topnav/operation_up.png').default),
                icon_down: (require('@/assets/image/topnav/operation_down.png').default),
                title: '市场管理',
                childrenNode: operationRoutes,
                component: Operationcd,
            },
            {
                path: '/audit',
                icon_up: (require('@/assets/image/topnav/audit_up.png').default),
                icon_down: (require('@/assets/image/topnav/audit_down.png').default),
                title: '审核管理',
                childrenNode: auditRoutes,
                component: Auditcd,
            },
            {
                path: '/user',
                icon_up: (require('@/assets/image/topnav/user_up.png').default),
                icon_down: (require('@/assets/image/topnav/user_down.png').default),
                title: '用户管理',
                childrenNode: userRoutes,
                component: UserCard,
            },
            {
                path: '/order',
                icon_up: (require('@/assets/image/topnav/order_up.png').default),
                icon_down: (require('@/assets/image/topnav/order_down.png').default),
                title: '订单管理',
                childrenNode: orderRoutes,
                component: OrderCard,
            },
            {
                path: '/client',
                icon_up: (require('@/assets/image/topnav/client_up.png').default),
                icon_down: (require('@/assets/image/topnav/client_down.png').default),
                title: '客户端管理',
                childrenNode: clientRoutes,
                component: ClientCard,
            },
            {
                path: '/market',
                icon_up: (require('@/assets/image/topnav/market_up.png').default),
                icon_down: (require('@/assets/image/topnav/market_down.png').default),
                title: '营销管理',
                childrenNode: marketRoutes,
                component: marketingCard,
            },
            {
                path: '/contract',
                icon_up: (require('@/assets/image/topnav/contract_up.png').default),
                icon_down: (require('@/assets/image/topnav/contract_down.png').default),
                title: '合同管理',
                childrenNode: contractRoutes,
                component: ContractCard,
            },
            {
                path: '/finance',
                icon_up: (require('@/assets/image/topnav/finance_up.png').default),
                icon_down: (require('@/assets/image/topnav/finance_down.png').default),
                title: '财务管理',
                childrenNode: financeRoutes,
                component: Financecd
            },
            {
                path: '/permissions',
                icon_up: (require('@/assets/image/topnav/permissions_up.png').default),
                icon_down: (require('@/assets/image/topnav/permissions_down.png').default),
                title: '权限管理',
                childrenNode: permissionsRoutes,
                component: PerCard
            },
            {
                path: '/aftersale',
                icon_up: (require('@/assets/image/topnav/aftersale_up.png').default),
                icon_down: (require('@/assets/image/topnav/aftersale_down.png').default),
                title: '售后管理',
                childrenNode: salesRoutes,
                component: AfterSaleCard
            },
            {
                path: '/companyhelp',
                icon_up: (require('@/assets/image/topnav/help_up.png').default),
                icon_down: (require('@/assets/image/topnav/help_down.png').default),
                title: '帮助中心',
                childrenNode: companyHelpRoutes,
                component: Companyhelpcd,
                type: 'company'
            },
            {
                path: '/system',
                icon_up: (require('@/assets/image/topnav/system_up.png').default),
                icon_down: (require('@/assets/image/topnav/system_down.png').default),
                title: '系统管理',
                childrenNode: systemRoutes,
                component: systemCard
            },
            {
                path: '/report',
                icon_up: (require('@/assets/image/topnav/report_up.png').default),
                icon_down: (require('@/assets/image/topnav/report_down.png').default),
                title: '报表管理',
                childrenNode: reportRoutes,
                component: ReportCard
            },
            {
                path: '/ais',
                icon_up: (require('@/assets/image/topnav/operation_up.png').default),
                icon_down: (require('@/assets/image/topnav/operation_down.png').default),
                title: '智能调度',
                childrenNode: [],
                component: null,
            },
        ]
    },
];

export default routes;